import { render, staticRenderFns } from "./i-view.vue?vue&type=template&id=234aa48f&scoped=true"
import script from "./i-view.vue?vue&type=script&lang=js"
export * from "./i-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234aa48f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234aa48f')) {
      api.createRecord('234aa48f', component.options)
    } else {
      api.reload('234aa48f', component.options)
    }
    module.hot.accept("./i-view.vue?vue&type=template&id=234aa48f&scoped=true", function () {
      api.rerender('234aa48f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/minbox/views/i-view.vue"
export default component.exports